<template>
  <b-card style="width: 100%" align="left">
    <template v-slot:header>
    </template>
    <b-container>
      <b-row>
        <b-col lg="2" style="margin-bottom: 20px">
          <b-button @click="backByOneRecord" variant="outline-primary">
            <b-icon icon="chevron-left" variant="success"></b-icon>
            Назад
          </b-button>
        </b-col>
        <b-col lg="10"></b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <b-table
              striped
              hover
              responsive="sm"
              :items="items"
              :fields="fields">
            <template v-slot:table-colgroup="scope">
              <col style="width: 40%" >
              <col style="width: 10%" >
              <col style="width: 50%" >
            </template>
          </b-table>
        </b-col>
      </b-row>

    </b-container>
    <template v-slot:footer>
      <b-container  class="text-right">
        <small>© Customer Service 2020</small>
      </b-container>
    </template>
  </b-card>
</template>

<script>
import RestApi from '../store/RestApi'
import _ from 'lodash'
import DataEmployee from './DataEmployee'
export default {
  name: 'OpenAnswerPage',
  data () {
    return {
      schemaForms: DataEmployee.getConfig(),
      items: [],
      fields: [
        { key: 'question', label: 'Вопрос', sortable: false },
        { key: 'CodeQuestion', label: 'Код вопроса', sortable: false },
        { key: 'Value', label: 'Ответ', sortable: false }
      ]
    }
  },
  mounted () {
    const api = new RestApi();
    if (this.$route.params.token === api.tokenAuth) {
      this.downloadsData()
    }
  },
  methods: {
    downloadsData () {
      const answerId = this.$route.params.answerId
      RestApi.GetAnswersById(answerId).then((responce) => {
        this.getConfig((objectQuestion) => {
          console.log(objectQuestion)
          _.forEach(responce.data, (node) => {
            node.question = objectQuestion[node.CodeQuestion]
            this.items.push(node)
          })
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    getConfig (cb) {
      let items = []
      _.forEach(this.schemaForms, (page) => {
        items = _.concat(items, page)
      })
      let objectQuestion = {}
      _.forEach(items, (item) => {
        if (item.codeQuestion !== '') {
          if (item.typeQuestion === 'textEditorDependOn') {
            const key = `${item.codeQuestion}_${item.dependsOn.codeQuestions}`

            const question = _.find(items, {codeQuestion: item.dependsOn.codeQuestions})

            const label = item.textQuestion
              .replace('{textQuestion}', question.textQuestion)
              .replace('{point}', 'XX')
            objectQuestion[key] = label
          } if (item.typeQuestion === 'multiSelect') {
            _.forEach(item.answers, (node) => {
              objectQuestion[node.codeQuestions] = node.text
            })
          } if (item.typeQuestion === 'formBalanced') {
            _.forEach(item.answers, (node) => {
              objectQuestion[node.codeQuestions] = node.text
            })
          } else {
            objectQuestion[item.codeQuestion] = item.textQuestion
          }
        }
      })
      cb(objectQuestion)
    },
    backByOneRecord () {
      console.log('forwardByOneRecord')
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/OpenAnswerPage.vue